var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3179,
    cy: 16.5071,
    r: 14.597,
    stroke: "#F5F5F5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3881 13.0884H16.6582C16.1575 13.0884 15.7516 13.4943 15.7516 13.995V14.3103C15.7516 14.811 16.1575 15.2169 16.6582 15.2169H21.3881C21.8888 15.2169 22.2947 14.811 22.2947 14.3103V13.995C22.2947 13.4943 21.8888 13.0884 21.3881 13.0884Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2747 11.7416C17.4112 11.6824 17.5311 11.5905 17.6239 11.4742C17.6702 11.4263 17.7104 11.3729 17.7435 11.3151L19.3371 8.55733C19.4442 8.37117 19.4731 8.1501 19.4174 7.94266C19.3617 7.73521 19.226 7.55834 19.04 7.45086L18.6008 7.19606C18.4144 7.08885 18.1932 7.05992 17.9855 7.1156C17.7778 7.17128 17.6007 7.30703 17.4929 7.49309L16.0852 9.93973L12.2083 11.6206C11.7517 11.6893 11.3348 11.9197 11.0336 12.2697C10.7324 12.6197 10.5668 13.0662 10.5669 13.528V13.8279L2.25 13.704V22.0378L10.7246 22.1659C10.8744 22.5119 11.1221 22.8066 11.4373 23.0137C11.7524 23.2208 12.1212 23.3313 12.4983 23.3315H13.281C13.5347 23.3317 13.7861 23.2819 14.0205 23.1849C14.255 23.0879 14.4681 22.9457 14.6476 22.7663C14.8271 22.5869 14.9695 22.3739 15.0667 22.1395C15.1638 21.9051 15.2138 21.6538 15.2138 21.4001V13.528C15.213 13.2482 15.151 12.9719 15.0322 12.7186L17.2747 11.7416Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3881 15.8042H16.6582C16.1575 15.8042 15.7516 16.2101 15.7516 16.7108V17.0261C15.7516 17.5268 16.1575 17.9327 16.6582 17.9327H21.3881C21.8888 17.9327 22.2947 17.5268 22.2947 17.0261V16.7108C22.2947 16.2101 21.8888 15.8042 21.3881 15.8042Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3881 18.521H16.6582C16.1575 18.521 15.7516 18.9269 15.7516 19.4276V19.7429C15.7516 20.2436 16.1575 20.6495 16.6582 20.6495H21.3881C21.8888 20.6495 22.2947 20.2436 22.2947 19.7429V19.4276C22.2947 18.9269 21.8888 18.521 21.3881 18.521Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3881 21.2363H16.6582C16.1575 21.2363 15.7516 21.6422 15.7516 22.1429V22.4582C15.7516 22.9589 16.1575 23.3648 16.6582 23.3648H21.3881C21.8888 23.3648 22.2947 22.9589 22.2947 22.4582V22.1429C22.2947 21.6422 21.8888 21.2363 21.3881 21.2363Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodIcon);
export default __webpack_public_path__ + "static/media/good-icon.93e1195f161586c3668763b3bd578765.svg";
export { ForwardRef as ReactComponent };